module.exports = __webpack_public_path__ + "static/media/aboutPicture1.21235211.jpeg";